export const COMMENT_MAX_RATE = 5;
export const COMMENT_MIN_RATE = 1;
